import { render } from "./AdminProfile.vue?vue&type=template&id=3c2257b5&scoped=true"
const script = {}

import "./AdminProfile.vue?vue&type=style&index=0&id=3c2257b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2257b5"]])

export default __exports__